import React from 'react';

const SubmitButton = (props) => {
    return (
        <button
            type="submit"
            className="btn btn-cw-green"
            style={props.style}
            disabled={props.loading === true || props.disabled}
        >
            {props.loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
            {!props.loading && props.buttonText}
        </button>
    );
};

export default SubmitButton;
